import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import { IDropdownItem, SimpleResult } from "@ryde/shared";

import { landingRoutesApiConst } from "../constants";
import { landingCompanyIdSelector } from "../selectors";
import { useLandingApiMethods } from "./use-landing-api-methods";

export const useLandingApiCourses = () => {
  const companyId = useRecoilValue(landingCompanyIdSelector);
  const coursesUrl = landingRoutesApiConst.courses(companyId as number);
  const { apiGet } = useLandingApiMethods();

  const getCoursesDropdownItems = useEvent(
    async (): Promise<SimpleResult<IDropdownItem[]> | undefined> => {
      const response = await apiGet<SimpleResult<IDropdownItem[]> | undefined>(
        coursesUrl.getDropdownItems,
        undefined,
        undefined,
        undefined,
        false, // authorize = false since it's public
      );

      return response?.data;
    },
  );

  const getStationsByCourseId = useEvent(
    async (
      courseId: number,
    ): Promise<SimpleResult<IDropdownItem[]> | undefined> => {
      const response = await apiGet<SimpleResult<IDropdownItem[]> | undefined>(
        coursesUrl.getStationsByCourse(courseId),
        undefined,
        undefined,
        undefined,
        false, // authorize = false since it's public
      );

      return response?.data;
    },
  );

  const getCampusStations = useEvent(
    async (): Promise<SimpleResult<IDropdownItem[]> | undefined> => {
      const response = await apiGet<SimpleResult<IDropdownItem[]> | undefined>(
        coursesUrl.getCampusStations,
        undefined,
        undefined,
        undefined,
        false, // authorize = false since it's public
      );

      return response?.data;
    },
  );

  return {
    getCoursesDropdownItems,
    getStationsByCourseId,
    getCampusStations,
  };
};
